import toast from "react-hot-toast";

// Function to sanitize user input to prevent CRLF injection
const sanitizeInput = (input: string) => {
  // Replace carriage return and line feed characters with safe alternatives
  return input?.replace(/[\r\n]/g, "");
};

export const errorToast = (text: string, duration: number = 5000) => {
  const sanitizedText = sanitizeInput(text); // Sanitize input
  toast.error(sanitizedText, {
    duration,
    style: {
      backgroundColor: "#FCF7F7",
      color: "#B59745",
    },
  });
};

export const successToast = (text: string, duration: number = 5000) => {
  const sanitizedText = sanitizeInput(text); // Sanitize input
  toast.success(sanitizedText, {
    duration,
    style: {
      backgroundColor: "#ecf1e8",
      color: "#65CC14",
    },
  });
};
